import { default as Modal } from './AbstractModal';

const REWARD_LAUNCHER_URL = "#smile-home"

export default class extends Modal {
    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = 'has-menu-open'

    onInit() {
        this.$close = this.$('close')[0]
        this.$rewardsButtons = this.el.querySelectorAll("[href='" + REWARD_LAUNCHER_URL + "']");
        this.bindEvents()
    }

    onDestroy() {
        this.unbindEvents()
    }

    onOpen() {
        this.call('close', null, 'Search')
        this.call('onPlay', null, 'Globe', 'menu')

        setTimeout(() => {
            this.$close.focus()
        }, 200)
    }

    onClose() {
        this.call('close', null, 'Accordions', 'menu')
        this.call('onStop', null, 'Globe', 'menu')
    }

    onRewardsClick() {
        this.close()
    }

    bindEvents() {
        this.onRewardsClickBind = this.onRewardsClick.bind(this)
        if (this.$rewardsButtons.length) {
            this.$rewardsButtons.forEach($rewardButton => {
                $rewardButton.addEventListener('click', this.onRewardsClickBind)
            })
        }
    }

    unbindEvents() {
        if (this.$rewardsButtons.length) {
            this.$rewardsButtons.forEach($rewardButton => {
                $rewardButton.removeEventListener('click', this.onRewardsClickBind)
            })
        }
    }
}